import React, { useState } from 'react';
import EmailTemplatesTab from '../components/qpsettings/EmailTemplatesTab';
import MasterValuesTab from '../components/qpsettings/MasterValuesTab';
import QPMethodsTab from '../components/qpsettings/QPMethodsTab';
import QuestionBankSettingsTab from '../components/qpsettings/QuestionBankSettingsTab';
import { useAuth } from '../context/AuthContext';

const tabs = [
  { id: 'email-templates', label: 'EMAIL TEMPLATES', icon: '✉' },
  { id: 'master-values', label: 'MASTER VALUES', icon: '▤' },
  { id: 'qp-methods', label: 'QP METHODS', icon: '⚙' },
  { id: 'qb-settings', label: 'QUESTION BANK SETTINGS', icon: '📚' },
];

function QPSettings() {
  const [activeTab, setActiveTab] = useState('email-templates');
  const { user } = useAuth();

  return (
    <div className="page-card">
      <div className="settings-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="settings-tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="settings-content">
        {activeTab === 'email-templates' && <EmailTemplatesTab tenantId={user?.tenantId} />}
        {activeTab === 'master-values' && <MasterValuesTab tenantId={user?.tenantId} />}
        {activeTab === 'qp-methods' && <QPMethodsTab tenantId={user?.tenantId} />}
        {activeTab === 'qb-settings' && <QuestionBankSettingsTab tenantId={user?.tenantId} />}
      </div>
    </div>
  );
}

export default QPSettings;
